import { cx } from "class-variance-authority";

import { renderMarkdown } from "../../components/Markdown";
import informationCircle from "../../img/information-circle.svg";
import { Svg } from "../../utils/svgIcon";
import { Tooltip } from "../Tooltip";

import * as theme from "./InfoTooltip.css";

interface InfoTooltipProps {
    text: string;
    size?: "large" | "small";
    className?: string;
}

function InfoTooltip({ text, size = "large", className }: InfoTooltipProps) {
    return (
        <Tooltip
            noWrapper
            overlayClassName={theme.overlay}
            title={renderMarkdown(text)}
        >
            <span className={cx(theme.trigger, className)}>
                <Svg src={informationCircle} className={theme.icons[size]} />
            </span>
        </Tooltip>
    );
}

export { InfoTooltip };
export type { InfoTooltipProps };
